(function () {
  'use strict';

  angular
    .module('app.search', [])

    .directive('searchResultAdvice', function () {
      return {
        restrict: 'E',
        scope: true,
        bindToController: {
          search: '@',
          device: '<'
        },
        controllerAs: 'searchCtrl',
        /* @ngInject */
        controller: ["$element", "$timeout", "HttpService", "productsGridService", function ($element, $timeout, HttpService, productsGridService) {
          var ctrl = this;

          ctrl.$onInit = function () {
            searchApi();
          };

          ctrl.loaded = function () {
            $timeout(function () {
              productsGridService.resizeGrid('searchResultAdvice', ctrl.device.size, true);
            });
          };

          // Functions

          function searchApi() {
            HttpService.post({
              url: '/Search/SearchQuery',
              data: {
                QueryFullText: ctrl.search,
                NbFrom: '0',
                NbSize: '100',
                FiltersSelected: [
                  {
                    FieldName: 'KeyWebAspect',
                    FieldValue: 'Advice'
                  }
                ]
              }
            })
            .then(function (data) {
              ctrl.items = data;
              ctrl.count = data.length;
              if (ctrl.count > 0) {
                $element.removeClass('hidden');
              }
            })
            .catch(function (error) {
              console.error(error);
            });
          }
        }]
      };
    });
})();
